import { config as luminateConfig } from '@frx/frx-services';
import { useConstituentInteractions } from '@frx/frx-react-context';
import { useApiParams } from './use-api-params';

export const useFundraiser = () => {
  const luminateProperties = luminateConfig(window.location);
  const { ctx, handleUpdateInteraction, handleLogInteraction } = useApiParams({
    id: luminateProperties.facebookFundraiserDismissTypeId,
    subject: 'facebook_message_dismiss',
  });

  const { data: fbFundraiserDismissInteraction, isInitialLoading } =
    useConstituentInteractions(ctx);

  const dismissExist = fbFundraiserDismissInteraction?.interaction.length;

  const handleFbFundraiserDismissInteraction = () => {
    if (dismissExist) {
      return handleUpdateInteraction(
        fbFundraiserDismissInteraction?.interaction[0]
      );
    }
    handleLogInteraction(ctx);
  };

  return {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dismissExist: dismissExist > 0,
    isInitialLoading,
    handleFbFundraiserDismissInteraction,
  };
};
